import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Khoahoc from "components/Quanlydaotao/Khoahoc/Khoahoc.js";
import Importfilegiaovien from "components/Importfile/Quanlydaotao/Importfilegiaovien.js";
import Importfilexetaplai from "components/Importfile/Quanlydaotao/Importfilexetaplai.js";
export default function Quanlydaotao() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Danh sách khóa học",
            tabContent: <Khoahoc />,
          },
          {
            tabName: "Import danh sách giáo viên",
            tabContent: <Importfilegiaovien />,
          },
          {
            tabName: "Import danh sách xe tập lái",
            tabContent: <Importfilexetaplai />,
          },
        ]}
      />
    </div>
  );
}
